const enum MakePick {
  ANONYMOUS = 'anonymous',
  UNVERIFIED = 'unverified',
  DEPOSIT = 'deposit',
  ADD_NEW_ENTRY = 'add-new-entry',
  ADD_NEW_ENTRY_DEPOSIT = 'add-new-entry-deposit',
  FIND_ANOTHER_CONTEST = 'find-another-contest',
  SAVED_PICKS = 'saved-picks',
}

export { MakePick };
